import React from 'react';
import Link from 'next/link';
import ContentContainer from '../../layout/content/ContentContainer';
import QuickFeatures from './QuickFeatures';

export function Home(props) {
  return (
    <>
      {/* <!--/ header block --> */}

      <ContentContainer
        title="School management, E-learning, Powerful Data Analytics & Communication Tools For Modern Schools"
        // imgSrc="/images/screenshots/school/ExamResults.png"
        imgSrc="/images/illustrations/manWomanAndManPointingAtChart.svg"
        imageLeft
        useH1
        imageQuality={100}
        imageIsPriority
        // imageHeight={900}
        // imageWidth={1440}
        use5050WidthInLargeScreen
      >
        <div className="flex flex-col mb-10 lg:items-start items-center">
          {/* <div className="w-12 h-12 inline-flex items-center  justify-center rounded-full bg-indigo-100 text-indigo-500 mb-5">
                            <ChatIcon className="w-6 h-6 " />
                        </div> */}
          <h5 className="text-white  mb-1">
            School management system designed to put the school management in the know, parents at
            the center of school communications, keep students engaged in their learning and making
            teachers' work easier.
          </h5>
          <p className="text-white  mb-1" />
          <p className="text-white  mt-1">
            Track students performance, plus save time & money by making better informed decisions
            with our <span className="text-indigo-500"> data analysis </span> tools. Our platform
            also allows schools to send vital, real-time information directly to parents and
            students via <span className="text-indigo-500">SMS</span> &{' '}
            <span className="text-indigo-500">Email</span>. Leverage the power of ShuleSuite
            communication.
          </p>
          <p className="mt-6">
            <Link href="/get-started">
              <a className="analytics-contact-us-link primary-button ">
                <span className="font-bold  flex items-baseline">
                  Get started today
                  <svg
                    className="w-4 h-4 ml-2 pt-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </span>
              </a>
            </Link>
          </p>
        </div>

        {/* Text explanation  */}
      </ContentContainer>

      <QuickFeatures />

      <ContentContainer
        title="Admin & staff portal accessed via your phone, tablet or computer"
        imgSrc="/images/illustrations/twoMenChart.png"
        id="school-management"
        imageHeight={350}
        whiteTheme
      >
        <div className="flex flex-col mb-10 lg:items-start items-center">
          <div className="flex-grow">
            <p className="">
              School management system designed to put the school management in the know, parents at
              the center of school communications, keep students engaged in their learning and
              making teachers' work easier.
            </p>

            <p className="">
              We aim to help schools have <b>all the activities</b> performed by a student in the
              course of learning done via the system then share the needed information transparently
              with the management, teachers, parents and the general school community (via the apps
              & web portals).
            </p>

            <h3 className="text-indigo-600 text-xl font-bold mb-3">Education institutions</h3>
            <p className="">
              Educational institutions are complex structures. While the learning process is taking
              place, there are numerous tasks and activities taking place at the same time: exams,
              issuing books to students, communication with parents, school events, online
              teaching/assignments/guidance, plus analysing and reporting information. Our mission
              is to give staff, students and parents one place to do all that, ensure there is easy
              flow of information and give real power to educational institutions.
            </p>
          </div>
        </div>
      </ContentContainer>
      <ContentContainer
        title="Parents & students portal"
        imgSrc="/images/screenshots/school/StudentDashboard.png"
        id="school-management"
        imageLeft
        // whiteTheme
        imageQuality={25}
        imageHeight={900}
        imageWidth={1440}
      >
        <div className="flex flex-col mb-10 lg:items-start items-center">
          <div className="flex-grow">
            <p className="">
              Parents often don’t get the information they need in time and feel detached from their
              children’s school. <br />
              They want to know what their children are up to, how they are performing, what dates
              school events are scheduled for, etc without having to come to the office or keep on
              calling the school.
            </p>

            <h3 className="text-indigo-600 text-xl font-bold mb-3">How things work today</h3>

            <p className="">
              Today, parents <b>do everything from their phones</b> from banking, government
              services to insurance and paying tax via their phone. ShuleSuite enables them to do
              the same with schooling for your school.
            </p>

            <p className="">
              They see everything from the school portal via their phone; can see when important
              events will be, can see the{' '}
              <b>exam reports & historical performance of the student, get notifications, </b>
              e.t.c
            </p>

            <p className="">
              This makes them happier and makes them proud; viewing their child’s school as modern
              and innovative.
            </p>
          </div>
        </div>
      </ContentContainer>

      <ContentContainer
        title="Send SMS messages & emails to the school community"
        imgSrc="/images/Communication.svg"
        whiteTheme
      >
        <div className="flex flex-col mb-10 lg:items-start items-center">
          <div className="flex-grow">
            <p className="">
              Have an AGM/Harambee coming up? Want to remind parents to complete the fee payment?
              Important announcement? No longer rely on students to deliver this information as it
              can get distorted or not delivered at all.
            </p>
            <p className="">
              With ShuleSuite, the staff, parents & students can immediately receive updates from
              the school office via technology that works for everyone: SMS.
            </p>
            <p className="">More bulky documents can also be delivered by email.</p>
          </div>
        </div>
      </ContentContainer>

      <ContentContainer
        title="Exams, exam results & exam reports"
        imgSrc="/images/screenshots/school/StudentExamResults.png"
        // whiteTheme
        imageLeft
        imageQuality={25}
        imageHeight={900}
        imageWidth={1440}
      >
        <div className="flex flex-col mb-10 lg:items-start items-center">
          <div className="flex-grow">
            <h3 className="text-indigo-600 text-xl font-bold mb-3">
              Interactive report cards with charts and graphs
            </h3>
            <p className="">
              No longer limit your exam report card to A4 size pages that students can hide or
              forge.
            </p>
            <p className="">
              ShuleSuite comes with <b>interactive reports</b> that involve{' '}
              <b>detailed charts and graphs</b> per subject etc, comparison with past exams, ranking
              viewed on the school portal.
            </p>
            <h3 className="text-indigo-600 text-xl font-bold mb-3">
              Send exam results via SMS & Email
            </h3>
            <p className="">
              The above results are also delivered via SMS and Email{' '}
              <b>guaranteeing the parents receive them</b>.
            </p>
          </div>
        </div>
      </ContentContainer>

      <ContentContainer
        title="E-Learning, assignments & holiday homework"
        imgSrc="/images/Analytics.svg"
        whiteTheme
      >
        <div className="flex flex-col mb-10 lg:items-start items-center">
          <div className="flex-grow">
            <p className="">
              ShuleSuite give schools tools to manage online assignments / homework.
            </p>
            <p className="">
              Students can now engage in a combination of in-person learning and virtual learning -
              can receive and do assignments and homework while at home, during weekends and even
              holidays.
            </p>
            <p className="">
              The teachers can configure all the types of assignments and the students will be able
              to submit the assignments using the system. The task of assessing the performance
              level of the students is simplified by the assignment records.
            </p>

            <h3 className="text-indigo-600 text-xl font-bold mb-3">The new normal</h3>
            <p className="">
              Remote learning and collaboration is the new norm for modern schools especially after
              the COVID-19 pandemic. As <b>Satya Nadella, the Microsoft CEO </b> put it, “We’ve seen
              two years’ worth of digital transformation in two months. From remote teamwork and
              learning to sales and customer service, to critical cloud infrastructure and security
              - we are working alongside customers every day to help them adapt and stay open for
              business in a world of remote everything.” (Jared Spataro and Microsoft 365, 2020)
            </p>
          </div>
        </div>
      </ContentContainer>

      <ContentContainer
        title="Library management system"
        imgSrc="/images/illustrations/textPage.svg"
        // whiteTheme
        // topic="E-Learning"
        imageLeft
      >
        <div className="flex flex-col mb-10 lg:items-start items-center">
          <div className="flex-grow">
            <p className="">
              How many ‘KLB Mathematics Book 4’ are in the library? Which books are often borrowed?
              How many books did student X borrow in the last month?
            </p>

            <p className="">
              ShuleSuite helps you answer these questions and more with the integrated Library
              Management System. It has a book information records system, issue and return books is
              done via the system, e.t.c
            </p>

            <p className="">
              Librarians have an online library management system they can use to issue books,
              receive books, analyse the most popular books, track & prevent book loss, e.t.c
            </p>
          </div>
        </div>
      </ContentContainer>

      <ContentContainer
        title="100% cloud-based school management system"
        imgSrc="/images/illustrations/manWomanAndManPointingAtChart.svg"
        whiteTheme
      >
        <div className="flex flex-col mb-10 lg:items-start items-center">
          <div className="flex-grow">
            <p className="">
              The 100% cloud-based school management system, available anytime from anywhere will
              prove to make you and your school proud. <br />
              It enables educational institutes to digitally monitor their daily activities along
              with organizing and managing all the resources and information on a single platform
              from anywhere in the world.
            </p>
            <p className="">It also makes processes dependent on automation and not on people.</p>
            <p className="">And has an almost zero cost of ownership and maintenance.</p>
            <h3 className="text-indigo-600 text-xl font-bold mb-3">Education institutions</h3>
            <p className="">
              Educational institutions are complex structures. While the learning process is taking
              place, there are numerous tasks and activities taking place at the same time: exams,
              issuing books to students, communication with parents, school events, online
              teaching/assignments/guidance, plus analyzing and reporting information. Our mission
              is to give staff, students and parents one place to do all that, ensure there is easy
              flow of information and give real power to educational institutions.
            </p>
            <h3 className="text-indigo-600 text-xl font-bold mb-3">
              Modern tech savvy institution
            </h3>
            <p className="">
              It comes with a customised website login with your school’s branding (logo, motto,
              etc.) and is a one point solution for total school management.
            </p>
            <p className="">
              This reflects your school unique brand and helps build an image of modern savvy
              institution.
            </p>
          </div>
        </div>
      </ContentContainer>

      <ContentContainer
        title="Data analytics & reports"
        imgSrc="/images/screenshots/school/ExamResults.png"
        imageHeight={900}
        imageWidth={1440}
        // whiteTheme
        // topic="E-Learning"
        imageLeft
      >
        <div className="flex flex-col mb-10 lg:items-start items-center">
          <div className="flex-grow">
            <p className="">
              ShuleSuite is the answer to your question: How has the student been performing for the
              last three years? What books are the students borrowing? Answer these and more
              questions through Interactive Charts, Graphs & Dashboards made from real-time data,
              gathered from all systems available to you, displayed in easy-to-understand dashboards
              that tell a clear story. We not only make it easy for teachers and parents but we also
              allow a student to understand how they have been performing and what they need to
              focus on, to perform better.
            </p>

            <p className="">
              ShuleSuite improves student learning outcomes by analysing and visualizing educational
              data. We make it easy for educators to come together and analyse and visualize their
              own data.
            </p>

            <p className="">
              Get any real answers from school data, no more time-consuming report writing or
              annoying excel sheets. Plus, relevance and accuracy are ensured!
            </p>
          </div>
        </div>
      </ContentContainer>
    </>
  );
}

export default Home;
